import { render, staticRenderFns } from "./BindActivityGoodsDialog.vue?vue&type=template&id=8bdc25ea&scoped=true&lang=pug&"
import script from "./BindActivityGoodsDialog.vue?vue&type=script&lang=ts&"
export * from "./BindActivityGoodsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BindActivityGoodsDialog.vue?vue&type=style&index=0&id=8bdc25ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdc25ea",
  null
  
)

export default component.exports